var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"integrate-search-history"},[_c('HistoryQueryLeftNav'),_c('router-view',{key:_vm.currentPath})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }